import styled from 'styled-components'
import {
    textColorStyles,
    textSizeStyles,
    textWeightStyles,
} from '../text/textStyles'
import {
    Dispatch,
    SetStateAction,
    forwardRef,
    useEffect,
    useState,
} from 'react'
import DatePicker from 'react-datepicker'
import { CalendarHeader } from './header'

const Container = styled.div`
    .react-datepicker__input-container {
        display: none;
    }

    .react-datepicker__portal {
        background: rgba(0, 0, 0, 0.2);
    }

    .react-datepicker {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.25);
        background: ${(p) => p.theme.colors.white};
        border-radius: 20px;
        border: none;
        padding: 32px;
    }

    .react-datepicker__header {
        background: none;
        border: none;
        padding: 0;
    }

    .react-datepicker__day-names {
        display: none;
    }

    .react-datepicker__month {
        display: flex;
        flex-direction: column;
        gap: 4px;
        margin: 0;
    }

    .react-datepicker__week {
        display: flex;
        justify-content: space-between;
    }

    .react-datepicker__day {
        width: 60px;
        padding: 16px 20px;
        margin: 0;

        ${textSizeStyles['medium']}
        ${textWeightStyles['medium']}

        &:hover {
            background: ${(p) => p.theme.colors.tertiary.tertiary50};
        }
    }

    .react-datepicker__day--outside-month {
        color: ${(p) => p.theme.colors.tertiary.tertiary200};
    }

    .react-datepicker__day--today {
        ${textColorStyles['brand']}
    }

    .react-datepicker__day--keyboard-selected {
        background: none;
    }

    .react-datepicker__day--selected {
        background: ${(p) => p.theme.colors.primary.default};
        ${textColorStyles['white']}

        &:hover {
            background: ${(p) => p.theme.colors.primary.default};
        }
    }
`

interface Props {
    selectedDates: Date[]
    onCalendarClose: (dates: Date[]) => void
}

export const Calendar = forwardRef<DatePicker, Props>((props, ref) => {
    const [dates, setDates] = useState<Date[]>([])
    const [newDateSelected, setNewDateSelected] = useState<Date>()

    useEffect(() => {
        setDates(props.selectedDates)
    }, [props.selectedDates])

    return (
        <Container>
            <DatePicker
                ref={ref}
                selectedDates={dates}
                selectsMultiple
                onChange={(newDates) => {
                    // selectsMultiple always passes an array; the picker's
                    // shared onChange type also allows a single date or null.
                    setDates(Array.isArray(newDates) ? newDates : [])
                }}
                onMonthChange={(newDate) => {
                    setNewDateSelected(newDate)
                }}
                onYearChange={(newDate) => {
                    setNewDateSelected(newDate)
                }}
                onCalendarClose={() => props.onCalendarClose(dates)}
                shouldCloseOnSelect={false}
                maxDate={new Date()}
                minDate={new Date(1990, 0, 1)}
                renderCustomHeader={(props) => {
                    return (
                        <CalendarHeader
                            newDateSelected={newDateSelected}
                            {...props}
                        />
                    )
                }}
                withPortal
            />
        </Container>
    )
})
